<div class="date-range-picker-desktop">
  <app-date-range-picker-desktop
    [firstDatePlaceholder]="desktopFirstDatePlaceholder"
    [secondDatePlaceholder]="desktopSecondDatePlaceholder"
    [skipText]="skipText"
    [noSkipText]="noSkipText"
  >
  </app-date-range-picker-desktop>
</div>
<div class="date-range-picker-mobile">
  <app-date-range-picker-mobile
    [datePlaceholder]="mobileDatePlaceholder"
    [confirmButtonText]="mobileConfirmButtonText"
    [skipButtonText]="mobileSkipButtonText"
    [headerTitle]="mobileHeaderTitle"
    [skipText]="skipText"
    [withSkip]="withSkip"
  ></app-date-range-picker-mobile>
</div>
